
import { defineComponent } from 'vue'
import { mapMutations, mapState, mapActions } from 'vuex';

export default defineComponent({
    name: 'SessionDeleteModal',
    methods: {
        toggleModal: function(){
            this.ToggleSessionDeleteModal();
        },
        removeSession(){
            this.deleteCurrentSession();
            window.location.reload()
        },
        ...mapMutations('modalModule', ['ToggleSessionDeleteModal']),
        ...mapActions('sessionsModule', ['deleteCurrentSession']),

    },
    computed: {
        ...mapState('modalModule', ['sessionDeleteModal']),
        ...mapState('sessionsModule', ['currentSession'])
    }
})
